import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/layouts/index.vue')

const routes: RouteRecordRaw = {
  path: '/user',
  component: Layout,
  redirect: '/user/index',
  name: 'User',
  meta: {
    title: '用户管理',
    i18n: 'route.breadcrumb.root',
    icon: 'ic:twotone-double-arrow',
  },
  children: [
    {
      path: 'index',
      name: 'UserIndex',
      component: () => import('@/views/user/index.vue'),
      meta: {
        title: '用户管理',
        sidebar: false,
        breadcrumb: false,
        activeMenu: "/user"
      },
    }
  ],
}

export default routes
